import { createApi } from '@reduxjs/toolkit/query/react';
import { BaseQueryWithReAuth } from '../utils';
import { userAccessPanelAPIDLMSEndpoints } from './dlms/endpoints';

export const userAccessPanelQuery = BaseQueryWithReAuth({
  baseUrl: `${import.meta.env.VITE_DLMS_BASE_URL}`,
  credentials: 'same-origin'
});

const userAccessPanelAPIDLMS = createApi({
  reducerPath: 'userAccessPanelAPIDLMS',
  baseQuery: userAccessPanelQuery,
  endpoints: (builder) => ({
    ...userAccessPanelAPIDLMSEndpoints(builder)
  })
});

export const { usePrefetch, useGetUsersListQuery, useCreateUserDLMSMutation } =
  userAccessPanelAPIDLMS;

export default userAccessPanelAPIDLMS;
